import MainLayout from '@/shared/Layouts/MainLayout'
import userAtom from '@/pages/User/user.atom'
import { useRecoilValue } from 'recoil'
import Skeleton from '@/shared/Loaders/Skeleton'
import MainGridLayout from './MainGridLayout'
import css from './mainPage.module.css'
import useTitle from '@/shared/hooks/useTitle'

const MainPage = () => {
  useTitle('Главная')
  const userState = useRecoilValue(userAtom)

  const nameTextRender = () => {
    if (!userState.userInfo)
      return (
        <Skeleton
          height="32px"
          width="80px"
          style={{ margin: '0 5px', display: 'inline-flex', verticalAlign: 'bottom' }}
        />
      )
    if (userState.userInfo.firstName)
      return <span className="text-heading-3">{`, ${userState.userInfo.firstName}`}</span>
    return ''
  }

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <h1 className="text-heading-3" style={{ margin: 0 }}>
          Добро пожаловать{nameTextRender()}!
        </h1>
        <MainGridLayout />
      </div>
    </MainLayout>
  )
}

export default MainPage
